import {AuthState} from './states/auth.state';

export const authStates = [
    AuthState
];

